// Early Bird wiki 弹窗的可分享深链：#earlybird/:id。要从主页面一路打开到弹窗，
// 中间要经过两层纯本地 state（PipelinePage.activeTab → EarlyBirdTab.wikiProject；
// EarlyRadarPanel 拉平之后不再自己维护 tab 状态，只是把 activeTab 原样传下去），
// 每一层都要在初始化时认得这个 hash，才能一路展开到正确的 tab。抽成纯函数方便
// 多处复用 + 单测，而不是在每个组件里各写一遍正则。
export function parseEarlyBirdShareId(hash) {
  const m = /^#?earlybird\/([^/?]+)/.exec(hash || '');
  return m ? decodeURIComponent(m[1]) : null;
}
